import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_USER_EVENT_TYPES,
  RECEIVE_USER_EVENTS,
  IOT_EVENTS_UPDATED,
  RECEIVE_SERIES_EVENTS,
  RECEIVE_NOTIFY_EVENTS,
  FETCH_EXPORT_EVENTS,
  EXPORTING_DONE,
  EVENT_IMPORT_ERRORS,
  EVENT_IMPORTED_AT,
  SET_IMPORT_ORDER,
} from './actions';

// Initial state

const initialState = {
  iotUpdatedAt: undefined,
  userEventTypes: [],
  isExporting: false,
  events: [],
  seriesEvents: [],
  eventNotifications: {
    overdueCount: 0,
    todoCount: 0,
    notifiedEvents: [],
  },
  importErrors: [],
  importedAt: 0,
  order: 'desc',
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_USER_EVENT_TYPES: {
      return { ...state, userEventTypes: action.userEventTypes };
    }
    case RECEIVE_USER_EVENTS: {
      return { ...state, events: action.events };
    }
    case RECEIVE_SERIES_EVENTS: {
      return { ...state, seriesEvents: action.events };
    }
    case RECEIVE_NOTIFY_EVENTS: {
      return {
        ...state,
        eventNotifications: {
          ...state.eventNotifications,
          overdueCount: action.eventCounts.overdueCount,
          todoCount: action.eventCounts.todoCount,
          notifiedEvents: action.eventCounts.notifiedEvents,
        },
      };
    }
    case IOT_EVENTS_UPDATED: {
      return { ...state, iotUpdatedAt: action.updatedAt };
    }
    case FETCH_EXPORT_EVENTS: {
      return { ...state, isExporting: true };
    }
    case EXPORTING_DONE: {
      return { ...state, isExporting: false };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        iotUpdatedAt: undefined,
        userEventTypes: [],
        isExporting: false,
        events: [],
        seriesEvents: [],
        eventNotifications: {
          overdueCount: 0,
          todoCount: 0,
          notifiedEvents: [],
        },
        importErrors: [],
        importedAt: 0,
      };
    }
    case EVENT_IMPORT_ERRORS: {
      return { ...state, importErrors: action.errors };
    }
    case EVENT_IMPORTED_AT: {
      return { ...state, importedAt: action.date };
    }
    case SET_IMPORT_ORDER: {
      return { ...state, order: action.order };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
